import DisplayComponent from './DisplayComponent';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

registerBlockType('ib-podcast/podcast-content', {
	title: __('Podcast Content', 'ib-podcast-content'),
	icon: 'analytics',
	category: 'layout',
	supports: {
		multiple: true,
	},
	edit: DisplayComponent,
	save: () => null,
});
